module.exports = __webpack_public_path__ + "images/emoji/arrow_heading_down.9694fc75a1f50eece009.png";